import React, { type PropsWithChildren } from 'react'
import { cn } from '~/shadcn/lib/utils'

export type SvgIconProps = PropsWithChildren<React.SVGProps<SVGSVGElement>>

export function SvgIcon({
  width,
  height,
  className,
  children,
  ...props
}: SvgIconProps) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={cn(className)}
      {...props}>
      {children}
    </svg>
  )
}
